import { Store } from 'game/store/gameStore';
import { DisplayValue } from './DisplayValue';
import { App } from 'game/core/pixiRenderer';

export default class TimeCounter extends DisplayValue {
    constructor() {
        super('time');
        this.update = this.update.bind(this);
        App.app.ticker.add(this.update);
        this.update();
        
    }

    update(): void {
        this.value.text = Store.getTimeFormat();
    }
}
